"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSwitch = void 0;
var palette_1 = require("../../../theme/global/palette");
var styles_1 = require("@material-ui/core/styles");
exports.MuiSwitch = {
    root: {
        margin: '8px 12px 8px 6px',
        width: 32,
        height: 18,
        padding: 0,
        borderRadius: 34,
        overflow: 'unset',
        '& .MuiButtonBase-root:hover': {
            backgroundColor: (0, styles_1.alpha)(palette_1.palette.grey[500], 0.2),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '& .MuiTouchRipple-rippleVisible': {
            color: (0, styles_1.alpha)(palette_1.palette.grey[500], 0.6),
        },
    },
    track: {
        borderRadius: '50px',
        opacity: '.48',
    },
    colorPrimary: {
        color: palette_1.palette.common.white,
        '&$checked': {
            color: palette_1.palette.common.white,
            '&:hover': {
                backgroundColor: (0, styles_1.alpha)(palette_1.palette.primary.light, 0.1),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        '&$disabled': {
            color: palette_1.palette.action.disabled,
        },
        '&$disabled + $track': {
            opacity: '.28',
        },
        '&$checked + $track': {
            backgroundColor: palette_1.palette.primary.main,
        },
    },
    switchBase: {
        top: -11,
        left: -11,
        padding: 13,
        '&$checked': {
            transform: "translateX(14px)",
            color: palette_1.palette.common.white,
            '& + $track': {
                opacity: 1,
                border: 'none',
            },
        },
    },
    thumb: {
        boxShadow: 'none',
        width: 14,
        height: 14,
        color: palette_1.palette.common.white,
    },
};
